import React from "react";
import { Paper, Skeleton, Stack } from "@mui/material";

export const TableSkeleton = () => (
  <Paper elevation={0} sx={{ p: 2, border: "1px solid #e0e0e0", borderRadius: 1 }}>
    <Stack spacing={1}>
      <Skeleton variant="rectangular" height={400} />
    </Stack>
  </Paper>
);